export enum SnackbarType {
  Info = 'info-snackbar',
  Warning = 'warning-snackbar',
  Error = 'error-snackbar',
}
